/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The list of available OCPP versions :
 * * V16J : OCPP Json 1.6
 */
export enum OcppVersion {
  V16J = 'V16J'
}
